<template>
    <div class="load-spinner">
        <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
</template>
<script>
export default {
    name: 'load-spinner',
    data () {
      return {
      }
  },
}
</script>
<style scoped>


</style>


// WEBPACK FOOTER //
// src/LoadSpinner.vue